module.exports = __webpack_public_path__ + "img/social-media-color-blocks-ford.08e0bfb1.png";